import cx from 'classnames';
import type { MouseEventHandler, PropsWithChildren, ReactNode } from 'react';
import { forwardRef } from 'react';

import { Button } from '@trello/nachos/button';
import type { TestId } from '@trello/test-ids';

import { useIsBoardHeaderAndMenuRedesignEnabled } from 'app/src/components/BoardHeader/useIsBoardHeaderAndMenuRedesignEnabled';

import * as styles from './BoardMenuButton.module.less';

interface BoardMenuButtonProps {
  iconBefore?: JSX.Element;
  className?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  testId?: TestId;
  disabled?: boolean;
  children?: ReactNode;
}

export const BoardMenuButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<BoardMenuButtonProps>
>(({ iconBefore, className, onClick, testId, disabled, children }, ref) => {
  const { menuRedesignEnabled } = useIsBoardHeaderAndMenuRedesignEnabled();
  return (
    <Button
      className={cx(
        styles.boardMenuButton,
        className,
        menuRedesignEnabled && styles.buttonIcon,
      )}
      iconBefore={iconBefore}
      onClick={onClick}
      testId={testId}
      isDisabled={disabled}
      ref={ref}
    >
      <div className={styles.buttonContents}>{children}</div>
    </Button>
  );
});
